export default __webpack_public_path__ + "static/media/clicked-link.e6bd44c5.svg";